<script setup lang="ts">
const props = defineProps<{
  modelValue?: boolean | null
}>()

const emit = defineEmits(['update:modelValue'])

const state = reactive<{
  checked: boolean
}>({
  checked: props.modelValue || false
})

const toggleState = () => {
  state.checked = !state.checked

  emit('update:modelValue', state.checked)
}
</script>

<template>
  <div>
    <slot :is-checked="state.checked" :on-click="toggleState" />
  </div>
</template>
